import type { ComposerAttachment } from '@dev-streetbeat/chat-ui'

import { ChipPreview } from './ChipPreview'
import type { ChatContextSelection } from './types'
import styles from './ContextChipBar.module.scss'

interface Props {
  attachments?: ComposerAttachment[]
  onRemoveAttachment?: (attachmentId: string) => void
  selection: ChatContextSelection
  onRemoveClient: () => void
}

function extensionOf(fileName: string): string {
  const idx = fileName.lastIndexOf('.')
  if (idx <= 0 || idx === fileName.length - 1) return 'FILE'
  return fileName.slice(idx + 1).toUpperCase()
}

export function ContextChipBar({
  attachments,
  onRemoveAttachment,
  selection,
  onRemoveClient,
}: Props) {
  const files = attachments ?? []
  const hasFiles = files.length > 0
  const hasClient = selection.client !== null
  if (!hasFiles && !hasClient) return null

  return (
    <div className={styles.bar} aria-label="Contesto della chat">
      {files.map((attachment) => (
        <ChipPreview
          key={attachment.id}
          label={attachment.file.name}
          tag={extensionOf(attachment.file.name)}
          onRemove={() => onRemoveAttachment?.(attachment.id)}
          removeAriaLabel={`Rimuovi file ${attachment.file.name}`}
        />
      ))}

      {selection.client ? (
        <ChipPreview
          label={selection.client.client_label}
          tag={selection.client.segment_name ?? 'Cliente'}
          onRemove={onRemoveClient}
          removeAriaLabel={`Rimuovi cliente ${selection.client.client_label}`}
          ftueStep="client-context-chip"
        />
      ) : null}
    </div>
  )
}
